import {  TextLink } from '@vds/buttons';
import { Row } from '@vds/grids';
import TravelPass from '@vds/icons/travel-pass';
import { Line } from '@vds/lines';
import { Notification } from '@vds/notifications';
import { Body, Title } from '@vds/typography';
import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { convertStringToElements } from '@vds/html-parsers';
import { useGetDevicesAndPlansByNameQuery } from '../../features/devicesAndPlans/devicesAndPlansFetch';
import AdvisoryDetails from '../../shared/components/AdvisoryDetails';
import Billchange from '../../shared/components/Billchange';
import ConnectedDeviceDetails from '../../shared/components/ConnectedDeviceDetails';
import DeviceDetails from '../../shared/components/DeviceDetails';
import ErrorPage from '../../shared/components/ErrorPage';
import Footer from '../../shared/components/Footer';
import Header from '../../shared/components/Header';
import FullPageLoader from '../../shared/components/Loader';
import { isDesktop, isACSS, isPOS, isNative, SessionIdGlobal, unauth, emptyRequestErrorFFlag } from '../../shared/utils/globalConfig';
import { addSpace,getDestList,getDestListName } from '../../shared/utils/globalUtils';
import { dispatchNotifyEvent, setCurrentPlanDetails,dispatchDeviceAndPlansImpression } from '../../shared/utils/tagging'
import { setRetainDatesAndDestinations,setConfirmationPage, setDevicesPlansAPIFetch,setUnauthToAuth, saveSelectedDestinations } from '../../features/selectedData/selectedDataReducer';
import Cookies from 'js-cookie';
import { savePersistantDestinations,saveDeviceDetails,savePersistantDates,clearConfirmedPlanData,saveDevicesAndPlansPayload, setSessionIdVar, setVarConfirmToDevice } from '../../features/selectedData/persistantDataReducer';
import Reptool from '../../shared/components/Reptool';
import WrapUp from '../../shared/components/wrapUp';
import {  nativeSetTitleOnly } from '../../shared/utils/native';
import xss from 'xss';
import NoplanModal from '../../shared/components/NoplanModal';
import { useItpPageTools } from '../../shared/hooks/useItpPageTools';
import { buildDevicePlanTools } from '../../shared/pageTools/itpPageTools';
import { openPlanForLine } from '../../shared/pageTools/openPlanForLine';


const DevicePageMain = styled.div`
`
const StyledRow = styled(Row)`

`;

const DevicePage = styled.div`

`
const Space = styled.div`
padding-top: ${props => props.pt || 12}px;
`
const StyledBlock = styled.div`
display: flex;
gap: 3px;
p {
min-width: 75px;
}
`

const StyledTextDiv = styled.div`
display:flex;
gap:2px;
width: auto;
max-width: 500px;
align-items: center;
`




const fetchValue = (sessionIdVar) => {
    return ((sessionIdVar === SessionIdGlobal)? false : true);
       
   }
const getValue = (unAuthSessionId, selectedDestinations) => {
    return((unAuthSessionId && unAuthSessionId !== undefined && selectedDestinations?.length==0)? true:false)
       
   }

export default function DevicesAndPlans() {
    const previousLocation = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const yourTripRef = useRef(null);
    const { selectedDestinations, selectedDates, confirmedPlanData, sessionIdVar, confirmToDeviceVar } = useSelector(state => state?.persistantReducer);
    const { failedUpdateCartData, devicesPlansAPIFetch,unauthToAuth } = useSelector(state => state?.selectedReducer);
    const { loadConfirmPage } = useSelector(state => state?.selectedReducer);
    const unAuthSessionId = Cookies.get('NsaUnAuthSessionId');
    let isUnauthToAuth = getValue(unAuthSessionId, selectedDestinations);
    let isStickyRequired = isNative;
    let isSesIdNotMatched =  false;
    if(!unauth && !isUnauthToAuth){
        isSesIdNotMatched =  fetchValue(sessionIdVar) ;}
    
    const getDevicesPayload = () => {
            const payload = {
                'destinationSelected': unAuthSessionId && unAuthSessionId !== undefined ? [] : getDestList(selectedDestinations, 'key'),
                "travelStartDate": unAuthSessionId && unAuthSessionId !== undefined ? '' : selectedDates?.travelStartDate,
                "travelEndDate": unAuthSessionId && unAuthSessionId !== undefined ? '' : selectedDates?.travelEndDate,
                "unAuthSessionId": unAuthSessionId && unAuthSessionId !== undefined ? unAuthSessionId : '',
                'destinationName': unAuthSessionId && unAuthSessionId !== undefined ? [] : getDestListName(selectedDestinations, 'name'),
            }
            return payload;
        }
        
    let isEmptyPayload = emptyRequestErrorFFlag && Object.keys(getDevicesPayload())?.length === 0 ;

    

    useEffect(() => {
        isUnauthToAuth && dispatch(setVarConfirmToDevice(false));

        if (isSesIdNotMatched && !unauth && !isUnauthToAuth) {
            dispatch(saveSelectedDestinations([]));
            dispatch(savePersistantDestinations([]));
            dispatch(savePersistantDates({}));
            dispatch(setSessionIdVar(""));
            window.location.href = xss('/digital/nsa/secure/ui/intl/trip/');
        }
    }, [])
    useEffect(() => {
        if (isEmptyPayload || ((selectedDestinations && selectedDestinations.length === 0 || 
            selectedDates.travelStartDate ==undefined && selectedDates.travelEndDate ==undefined) && !unAuthSessionId)) {
            navigate('/', { replace: true })
        }

    }, [selectedDestinations])

    useEffect(() => {
        setTimeout(() => {
        if (yourTripRef.current) {
            triggerClick();
        }
    }, 200)
      
    });
    const triggerClick = () => {
        console.log("Your trip clicked");
      };

   


    const { data, error, isLoading, isSuccess } = useGetDevicesAndPlansByNameQuery(getDevicesPayload(),
    {skip: ((selectedDestinations && selectedDestinations.length === 0 ||
    selectedDates?.travelStartDate ==undefined && selectedDates?.travelEndDate ==undefined) 
    && !unAuthSessionId) || unauthToAuth || isSesIdNotMatched || isEmptyPayload || confirmToDeviceVar},
    { refetchOnMountOrArgChange: devicesPlansAPIFetch });

  
    const [deviceSelectionData, setDeviceSelectionData] = useState();
    const [flightReviewDetailObject, setFlightReviewDetailObject] = useState();
    const [pendingOrderObject, setPendingOrderObject] = useState();
    const [wrapUpData,setWrapUpData] = useState();
    const [showNoPlanChangeModal, setShowNoPlanChangeModal] = useState(false);
    const [noPlanChangeModalData, setNoPlanChangeModalData] = useState(null);   
    
    useEffect(() => {
        if(data!=undefined){
        setDeviceSelectionData(data?.body?.data?.devicesAndPlans)
        setPendingOrderObject(data?.body?.data?.pendingOrder)
        setNoPlanChangeModalData(data?.body?.data?.noPlanChangeModal)
        setFlightReviewDetailObject(data?.body?.data?.inFlightReviewDetailObject)
        setWrapUpData(data?.body?.data?.wrapUpRepTool)
        if(selectedDestinations && selectedDestinations.length !== 0)
        {dispatch(setRetainDatesAndDestinations(true));}
        if(devicesPlansAPIFetch) {
            dispatch(setDevicesPlansAPIFetch(false))
        }}
    }, [data]);


    // for unauth to auth flow to retain the dates and destinations from device response and also to clear the confirmedplandata
    useEffect(() => {
        if (data!=undefined && unAuthSessionId && unAuthSessionId !== undefined && selectedDestinations.length==0) {
            if(data?.body?.data?.devicesAndPlans?.selectedDestinations)
            dispatch(savePersistantDestinations((data?.body?.data?.devicesAndPlans?.selectedDestinations)));
            if(data?.body?.data?.devicesAndPlans?.selectedDates){
           dispatch(savePersistantDates(data?.body?.data?.devicesAndPlans?.selectedDates));}
           dispatch(clearConfirmedPlanData());
           dispatch(setRetainDatesAndDestinations(true));
           dispatch(setUnauthToAuth(true))
           Cookies.remove('NsaUnAuthSessionId');
           dispatch(setSessionIdVar(SessionIdGlobal));
        }
    }, [data]);

    //to save devices payload 
    useEffect(()=>{
        dispatch(saveDevicesAndPlansPayload(getDevicesPayload()))
    },[data])

    

    //Tagging
    useEffect(() => {

        if (deviceSelectionData?.notification) {
            dispatchNotifyEvent(deviceSelectionData?.notification?.text)
        }
        if (deviceSelectionData?.onlyAirPlane && deviceSelectionData?.airplaneNotificationText) {
            dispatchNotifyEvent(deviceSelectionData?.airplaneNotificationText, "99")
        }
        if (deviceSelectionData?.payGoOnly && deviceSelectionData?.payGoOnlyNotificationText) {
            dispatchNotifyEvent(deviceSelectionData?.payGoOnlyNotificationText, "99")
        }
        if (deviceSelectionData?.mixedPayGo && deviceSelectionData?.mixedPayGoNotificationText) {
            dispatchNotifyEvent(deviceSelectionData?.mixedPayGoNotificationText)
        }
        if(deviceSelectionData?.deviceDetails)
            setCurrentPlanDetails(deviceSelectionData?.deviceDetails,"#device_page", confirmedPlanData.length === 0 ? "device and plan selection" : "review plan selection");
        
    }, [deviceSelectionData])

   

    useEffect(() => {
        window.scrollTo(0, 0);
        if(isNative){
            nativeSetTitleOnly("International Plans");
        }
    }, [])

      const OnConfirmButtonClicks = () => {

        const noPlanChange = (confirmedPlanData.length === 0);
        const hasBlockingCondition = hasBlockingConditions();
        const acssPosEnable = (isACSS || isPOS);
        const onlyAirPlane = deviceSelectionData?.onlyAirPlane;
        
        if (noPlanChange && noPlanChangeModalData && !onlyAirPlane && !hasBlockingCondition && !acssPosEnable) {
            setShowNoPlanChangeModal(true);
            return;
        }
        
        Cookies.remove('NsaUnAuthSessionId');
        dispatch(setUnauthToAuth(false))
        dispatch(saveDeviceDetails(data?.body?.data?.devicesAndPlans?.deviceDetails));
        dispatchDeviceAndPlansImpression(deviceSelectionData?.deviceDetails,confirmedPlanData,failedUpdateCartData)
        dispatch(setConfirmationPage(true));
        navigate("/itpconfirmation");
    };

    const openEditTripLink = (ctaUrl) => {
        if (previousLocation?.state === '/itptraveldates') {
            navigate("/itpdestination");
        } else {
            navigate(ctaUrl,{replace:true})
        }
    }

    const checkRecurringPlan = () => {
        if(confirmedPlanData.find((plan) => plan?.recurringPlan === true)){
            return true;
        } else {
            return false;
        }
    };

    
    const hasBlockingConditions = () => {
        if (!deviceSelectionData?.deviceDetails || deviceSelectionData.deviceDetails.length === 0) {
            return false;
        }

        return deviceSelectionData.deviceDetails.every(device => 
            device.hasPendingOrder === true || 
            device.hasMultiPendingOrder === true || 
            device.restrictedDevice === true || 
            device.travelReady === false ||
            device.onlyCanadaMexicoCovered === true
        );
    };

    const devicePlanTools = buildDevicePlanTools({
        devices: deviceSelectionData?.deviceDetails,
        stagedPlanChanges: confirmedPlanData,
        isBlocked: hasBlockingConditions,
        onConfirm: OnConfirmButtonClicks,
        onOpenPlanForLine: selectedDevice =>
            openPlanForLine(selectedDevice, { dispatch, navigate }),
    });

    useItpPageTools('intl-nsa-devices', devicePlanTools);

    

   

    return (
        <DevicePageMain id="device_page">
            {(isSuccess && deviceSelectionData) ?
                (<>
                    {deviceSelectionData?.notification &&
                        <Notification
                            type={deviceSelectionData?.notification?.type}
                            title={deviceSelectionData?.notification?.text}
                            fullBleed={true}
                            bold={false}
                            inline={false}
                            disableFocus={true}
                            hideCloseButton={false}
                        />}
                    <Space pt={48} />
                    <DevicePage >
                        <Header data-testid="pageTitleId" pageTitle={deviceSelectionData?.pageTitle} progressData={deviceSelectionData?.progressBar}></Header>
                        <Title size="large" ref= {yourTripRef} onClick={triggerClick} primitive="h3">{deviceSelectionData?.heading}</Title>
                        <Space />
                        <Body size="large">{deviceSelectionData?.travelDates}</Body>
                        <StyledBlock><Body size="large">{deviceSelectionData?.travelLabel}</Body>
                        {deviceSelectionData?.travelingCountries && <Body size="large" bold={true}>{addSpace(deviceSelectionData?.travelingCountries, ',')}</Body>}</StyledBlock>
                        <Space />
                        <TextLink onClick={() => { openEditTripLink(deviceSelectionData?.editTripCtaList[0].ctaUrl) }}>{deviceSelectionData?.editTripCtaLabel}</TextLink>
                        <Space pt={36} />
                        {deviceSelectionData?.payGoOnly && deviceSelectionData?.payGoOnlyNotificationText &&
                            <Notification
                                type="error"
                                title={convertStringToElements(deviceSelectionData?.payGoOnlyNotificationText)}
                                fullBleed={false}
                                inline={false}
                                disableFocus={true}
                                hideCloseButton={true}
                            />}

                        {deviceSelectionData?.mixedPayGo && deviceSelectionData?.mixedPayGoNotificationText &&
                            <Notification
                                type="warning"
                                title={convertStringToElements(deviceSelectionData?.mixedPayGoNotificationText)}
                                fullBleed={false}
                                inline={false}
                                disableFocus={true}
                                hideCloseButton={true}
                            />}
                        <Space pt={24} />
                        <Line type="secondary" />
                        <Space pt={24} />
                        <Title size="large" primitive="h4">{deviceSelectionData?.tripSubHeading}</Title>
                        <Space pt={24} />
                        {deviceSelectionData?.discountedCustomer && <><Body size="large">{deviceSelectionData?.discountedPlans}</Body><Space pt={24}/></>}                        
                        {deviceSelectionData?.subHeadingText &&
                            <StyledTextDiv>
                                <TravelPass
                                    color="#0089EC"
                                    size="45px"
                                />
                                <Body size="medium">{deviceSelectionData?.subHeadingText}</Body>
                            </StyledTextDiv>}
                        {deviceSelectionData?.onlyAirPlane && deviceSelectionData?.airplaneNotificationText &&
                            <Notification
                                type="error"
                                hideCloseButton="true"
                                title={deviceSelectionData?.airplaneNotificationText}
                                fullBleed={false}
                                inline={false}
                                disableFocus={true}
                            />}
                        
                        <Space pt={36} />
                        <StyledRow>
                            {deviceSelectionData?.deviceDetails?.map((deviceDetailInfo, i) => (
                                <DeviceDetails
                                  key={deviceDetailInfo?.id}
                                    deviceDetailInfo={deviceDetailInfo}
                                    onlyAirPlane={deviceSelectionData?.onlyAirPlane}
                                    flightReviewDetailObject={flightReviewDetailObject}
                                    domesticTooltip={deviceSelectionData?.domesticTooltip}
                                    pendingOrderObject={pendingOrderObject}
                                    showNoPlanChangeModal={showNoPlanChangeModal}
                                >
                                </DeviceDetails>
                            ))}
                            {deviceSelectionData?.deviceDetails?.map((deviceDetailInfo, i) => (
                                <AdvisoryDetails
                                    deviceDetailInfo={deviceDetailInfo}
                                    travelReadynotification={deviceSelectionData?.travelReadynotification}>
                                </AdvisoryDetails>
                            ))}
                            {deviceSelectionData?.connectedDevicesAvailable &&
                                < ConnectedDeviceDetails
                                    connectedDevices={deviceSelectionData?.connectedDevices}></ConnectedDeviceDetails>}
                        </StyledRow>
                        <Space pt={28} />
                        {wrapUpData && (isACSS || isPOS) && <WrapUp wrapUpData = {wrapUpData}></WrapUp>}

                        {checkRecurringPlan() && <Billchange />}
                        <Space pt={24} />
                        <Footer ctaLabel={deviceSelectionData?.ctaList[0]?.ctaLabel} handleButtonChange={OnConfirmButtonClicks} disabled={deviceSelectionData?.confirmDisable} btn= {!isStickyRequired } btn2= {true} confirmedPlanDataLength={confirmedPlanData.length} ctaLabel2={deviceSelectionData?.ctaLabel2}></Footer>
                        {(isACSS || isPOS) &&<Reptool deviceSelectionData={deviceSelectionData?.deviceDetails}></Reptool>}                            
                        
                        {showNoPlanChangeModal && noPlanChangeModalData && <NoplanModal showNoPlanChangeModal={showNoPlanChangeModal}  noPlanChangeModalData={noPlanChangeModalData} setShowNoPlanChangeModal={setShowNoPlanChangeModal} deviceSelectionData={deviceSelectionData} /> }
                    </DevicePage>

                    {/* {showPaygoRatesModal &&
                        <PaygoRatesModal
                            setPaygoRatesModal={setPaygoRateModal}
                        />
                    } */}
                   
                </>
                )
                : (error && <ErrorPage errorDetails={error?.data} />)

            }
            {isLoading && <FullPageLoader />}
        </DevicePageMain>
    )
}